"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));
var _react = _interopRequireDefault(require("react"));
var _clsx2 = _interopRequireDefault(require("clsx"));
var _commonCta = require("@mmc/common-cta");
var _dropdown = _interopRequireDefault(require("./dropdown.css"));
var CONTENT_PADDING = 20;
var getContentDirection = function getContentDirection(node, width) {
  var _node$getBoundingClie = node.getBoundingClientRect(),
    left = _node$getBoundingClie.left;
  return typeof window !== 'undefined' && left + width + CONTENT_PADDING >= window.innerWidth ? 'left' : 'right';
};
var Dropdown = /*#__PURE__*/function (_React$PureComponent) {
  (0, _inheritsLoose2["default"])(Dropdown, _React$PureComponent);
  function Dropdown(props) {
    var _this;
    _this = _React$PureComponent.call(this, props) || this;
    _this.state = {
      isOpen: props.isOpen || false,
      direction: props.direction
    };
    _this.containerRef = /*#__PURE__*/_react["default"].createRef();
    _this.open = _this.open.bind((0, _assertThisInitialized2["default"])(_this));
    _this.close = _this.close.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleApply = _this.handleApply.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleCancel = _this.handleCancel.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleBlur = _this.handleBlur.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }
  var _proto = Dropdown.prototype;
  _proto.componentDidMount = function componentDidMount() {
    document.addEventListener('mousedown', this.handleBlur);
  };
  _proto.componentWillUnmount = function componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleBlur);
  };
  _proto.handleApply = function handleApply() {
    var onApply = this.props.onApply;
    this.close();
    onApply();
  };
  _proto.handleCancel = function handleCancel() {
    var onCancel = this.props.onCancel;
    this.close();
    onCancel();
  };
  _proto.handleBlur = function handleBlur(event) {
    var isOpen = this.state.isOpen;
    if (!isOpen) {
      return;
    }
    var onCancel = this.props.onCancel;
    var onClose = this.props.onClose;
    if (!this.containerRef.current.contains(event.target)) {
      onCancel();
      onClose();
      this.close();
    }
  };
  _proto.open = function open() {
    var _this$props = this.props,
      width = _this$props.width,
      onOpen = _this$props.onOpen;
    this.setState({
      isOpen: true,
      direction: getContentDirection(this.containerRef.current, width)
    });
    onOpen();
  };
  _proto.close = function close() {
    this.setState({
      isOpen: false
    });
  };
  _proto.render = function render() {
    var _clsx;
    var _this$state = this.state,
      isOpen = _this$state.isOpen,
      direction = _this$state.direction;
    var _this$props2 = this.props,
      actionsClassName = _this$props2.actionsClassName,
      children = _this$props2.children,
      className = _this$props2.className,
      testID = _this$props2['data-testid'],
      id = _this$props2.id,
      theme = _this$props2.theme,
      label = _this$props2.label,
      placeholder = _this$props2.placeholder,
      width = _this$props2.width,
      applyButtonLabel = _this$props2.applyButtonLabel,
      cancelButtonLabel = _this$props2.cancelButtonLabel,
      hasActionButtons = _this$props2.hasActionButtons;
    var dropdownLabel = /*#__PURE__*/_react["default"].createElement("label", {
      htmlFor: id,
      className: (0, _clsx2["default"])(theme.colorDarkGrey, _dropdown["default"].label)
    }, label);
    return /*#__PURE__*/_react["default"].createElement("div", {
      style: {
        width: width
      },
      ref: this.containerRef,
      "data-testid": testID,
      className: (0, _clsx2["default"])(_dropdown["default"].dropdown, className)
    }, label && dropdownLabel, /*#__PURE__*/_react["default"].createElement("button", {
      id: id,
      className: _dropdown["default"].openBtn,
      type: "button",
      onClick: this.open
    }, /*#__PURE__*/_react["default"].createElement("span", {
      className: _dropdown["default"].placeholder
    }, placeholder), /*#__PURE__*/_react["default"].createElement("span", {
      className: (0, _clsx2["default"])(_dropdown["default"].triggerIcon, theme.mmcIconChevronDown)
    })), isOpen && /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _clsx2["default"])(_dropdown["default"].content, (_clsx = {}, _clsx[_dropdown["default"].contentLeft] = direction === 'left', _clsx))
    }, label && dropdownLabel, /*#__PURE__*/_react["default"].createElement("div", {
      className: _dropdown["default"].contentTitle
    }, /*#__PURE__*/_react["default"].createElement("span", null, placeholder), /*#__PURE__*/_react["default"].createElement("button", {
      type: "button",
      onClick: this.close
    }, /*#__PURE__*/_react["default"].createElement("span", {
      className: theme.mmcIconChevronUp
    }))), children, hasActionButtons && /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _clsx2["default"])(_dropdown["default"].actions, actionsClassName)
    }, /*#__PURE__*/_react["default"].createElement(_commonCta.CommonCta, {
      ariaLabel: "Apply",
      theme: theme,
      data: {
        priority: 'critical',
        label: applyButtonLabel
      },
      clickEvent: this.handleApply,
      spanClasses: theme['start-xs']
    }), /*#__PURE__*/_react["default"].createElement(_commonCta.CommonCta, {
      ariaLabel: "Cancel",
      theme: theme,
      data: {
        priority: 'low',
        label: cancelButtonLabel
      },
      clickEvent: this.handleCancel
    }))));
  };
  return Dropdown;
}(_react["default"].PureComponent);
exports["default"] = Dropdown;
Dropdown.defaultProps = {
  width: 200,
  hasActionButtons: false,
  direction: 'right',
  isOpen: false,
  applyButtonLabel: 'Apply',
  cancelButtonLabel: 'Cancel',
  onApply: function onApply() {
    return undefined;
  },
  onCancel: function onCancel() {
    return undefined;
  },
  onOpen: function onOpen() {
    return undefined;
  },
  onClose: function onClose() {
    return undefined;
  }
};